// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__4kG1v"};